import React from "react";
import "./PagingModule.css";
import { ArrowRight, ChevronRight, FolderPlus, Save } from "react-feather";

export class PagingModule extends React.Component {
    constructor(props) {
        super(props);
        this.logger = window.BaseLogger;

        this.state = {
            pageSize: 20,
        };

        this.onPageSizeChanged = this.onPageSizeChanged.bind(this);
        this.onPdfClick = this.onPdfClick.bind(this);
        this.onCsvClick = this.onCsvClick.bind(this);
    }

    onPageSizeChanged(event) {
        var pageSize = event.target.value;
        this.setState({
            pageSize: pageSize,
        });

        if (this.props.onPageSizeChanged) {
            this.props.onPageSizeChanged(pageSize);
        }
    }

    onPdfClick() {
        if (this.props.onPdfClick) {
            this.props.onPdfClick();
        }
    }

    onCsvClick() {
        if (this.props.onCsvClick) {
            this.props.onCsvClick();
        }
    }

    render() {
        var self = this;
        return (
            <div className="paging-module-container">
                <div className="paging-controls-toolbar">
                    <div className="paging-controls-buttons">
                        <span
                            className={this.props.isFirst == true ? "disabled" : ""}
                            onClick={this.props.onFirstClick}
                        >
                            &laquo;
                        </span>
                        <span
                            className={this.props.isFirst == true ? "disabled" : ""}
                            onClick={this.props.onPreviousClick}
                        >
                            &lsaquo;
                        </span>
                    </div>
                    <select
                        id="page_size_selector"
                        className=""
                        onChange={this.onPageSizeChanged}
                        value={this.state.pageSize}
                    >
                        <option value="20">20 Items</option>
                        <option value="50">50 Items</option>
                        <option value="100">100 Items</option>
                        <option value="200">200 Items</option>
                    </select>

                    <div className="paging-controls-buttons">
                        <span onClick={this.onPdfClick}>
                            <Save /> PDF
                        </span>
                        <span onClick={this.onCsvClick}>
                            <Save /> CSV
                        </span>
                        {/* <button className="btn btn-success btn-sm" onClick={this.onPdfClick}>
                            <span className="glyphicon glyphicon-floppy-save"></span> PDF
                        </button>
                        <button className="btn btn-success btn-sm" onClick={this.onCsvClick}>
                            <span className="glyphicon glyphicon-floppy-save"></span> CSV
                        </button> */}
                    </div>
                    <div className="paging-controls-text">
                        <span>{this.props.pageIndex + 1 + " of " + this.props.totalPageCount}</span>
                    </div>
                    <div className="paging-controls-buttons">
                        <span className={this.props.isLast == true ? "disabled" : ""} onClick={this.props.onNextClick}>
                            &rsaquo;
                        </span>
                        <span className={this.props.isLast == true ? "disabled" : ""} onClick={this.props.onLastClick}>
                            &raquo;
                        </span>
                    </div>
                </div>
            </div>
        );
    }
}
